var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlsLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 96 32",
    width: 96,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90.4368 31.8606c2.9162 0 5.2801-2.3562 5.2801-5.2628s-2.3639-5.2628-5.2801-5.2628c-2.9161 0-5.2801 2.3562-5.2801 5.2628s2.364 5.2628 5.2801 5.2628z",
    fill: "#ffd100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.1872 14.906v6.8859h5.7478c-.8398 1.3135-2.7334 2.0133-4.017 2.0133-4.3265 0-6.4898-2.4579-6.4898-7.4179 0-5.4772 2.8552-8.27983 8.5233-8.27983 2.2498 0 5.1925.56031 8.3503 1.55276v-8.23677c-.9092-.38791-2.2929-.689614-4.067-.992453-1.8173-.301705-3.4184-.431007-4.8033-.431007-5.6249 0-10.08118 1.50966-13.41198 4.52784-3.33193 3.01932-5.01952 7.07306-5.01952 12.20546 0 4.7002 1.29841 8.4092 3.89409 11.1268 2.59567 2.7595 6.10058 4.1399 10.51361 4.1399 4.4312 0 8.5028-2.2923 9.8148-5.2027l-.0284 4.6844h6.4101v-16.5757z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.8042 31.4814v-30.964432h9.9514v22.900032h10.8595v8.0644z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.2463 30.7058v-8.4522c1.4714.4741 3.2022.862 5.1492 1.2079 1.9471.3448 3.6347.5172 5.0628.5172 2.4227 0 3.6779-.6034 3.6779-1.682 0-.6896-.3892-1.0356-2.1633-1.4235l-3.4616-.7758c-5.9276-1.3373-8.6963-4.3123-8.6963-9.3585 0-3.32104 1.1687-5.95132 3.4617-7.89199 2.2907-1.898695 5.4929-2.84691 9.5167-2.84691 2.7686 0 7.0098.560309 9.6055 1.20795v8.06437c-1.3417-.3448-2.9416-.68961-4.8887-.99245-1.947-.3017-3.4616-.43101-4.5859-.43101-2.1201 0-3.332.60341-3.332 1.68206 0 .64648.5622 1.07868 1.7308 1.38038l4.0239.9482c5.8843 1.3804 8.6097 4.3985 8.6097 9.5309 0 3.2779-1.2119 5.8651-3.5913 7.7627-2.3795 1.8975-5.6682 2.8458-9.865 2.8458-3.9806 0-8.0044-.5603-10.2541-1.2931z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlsLogoWhite);
export default __webpack_public_path__ + "static/media/gls-logo-white.b245b4bfcd7e68dff6ddf15c5ff33d5f.svg";
export { ForwardRef as ReactComponent };